export default __webpack_public_path__ + "images/0X.27b6cba.png";